module.exports = __webpack_public_path__ + "static/dinosaur4-ae9b191a42fa610b8031dd3de4a64e84.png";